<template>
    <div>
        <posts :posts="posts" :is-section-show="isSectionShow" :is-category-show="isCategoryShow" :is-author-show="isAuthorShow"></posts>

        <a href="#" class="btn btn-light btn-block" v-if="loading == false" v-on:click="this.loadPosts">
            {{ $root.translate('label.view_more') }}
        </a>
        <div class="page-load-status" v-if="loading == true">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Posts from './Posts';
    export default {
        name: 'SectionPosts',
        components: {
            Posts,
        },
        data() {
            return {
                posts: [],
                errors: [],
                page: 1,
                loading: false,
                isSectionShow: false,
                isCategoryShow: true,
                isAuthorShow: true
            }
        },
        props: [
            'sectionId',
            'page',
        ],
        methods: {
            loadPosts: function(e) {
                e.preventDefault();
                this.loading = true;
                this.page++;

                let baseUri = process.env.MOVEEK_API_ENDPOINT;
                axios.get(baseUri + '/v1/posts?section.id=' + this.sectionId + '&page=' + this.page + '&page_size=20&status=publish&publish_at[strictly_before]=' + encodeURIComponent(this.$root.moment().toISOString(true)))
                    .then(response => {
                        this.posts.push(...response.data);
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
                    .finally(() => {
                        this.loading = false;
                    });

            }
        },
        created() { }
    }
</script>

<style scoped>
    .page-load-status { display: block; }
</style>
